import React from 'react';

import { MenuChatContextProvider } from 'contexts/MenuChat';
import { DetailsQuoteContextProvider } from 'contexts/DetailsQuote';
import { TableSearchProtocolContextProvider } from 'contexts/TableSearchProtocol';
import { LegalDocumentContextProvider } from 'contexts/LegalDocument';
import { TicketsContextProvider } from 'contexts/Tickets';

const AppContextProvider: React.FC<{ children: React.ReactNode; }> = ({ children }) => {
  return (
    <TicketsContextProvider>
      <TableSearchProtocolContextProvider>
        <DetailsQuoteContextProvider>
          <MenuChatContextProvider>
            <LegalDocumentContextProvider>
              {children}
            </LegalDocumentContextProvider>
          </MenuChatContextProvider>
        </DetailsQuoteContextProvider>
      </TableSearchProtocolContextProvider>
    </TicketsContextProvider>
  );
};

export default AppContextProvider;
